import { useEffect } from "react";
import { useDispatch } from "react-redux";
import axios from "axios";
import { setUser, setHandleError } from "../slices/UserInformation";
import { url } from "../url";

const GetProfile = () => {
    const dispatch = useDispatch();
    const token = localStorage.getItem("accessToken");

    useEffect(() => {
        let cancelled = false;

        // Guests should not trigger an authenticated profile request.
        if (!token) {
            dispatch(setUser({
                accessToken: null,
                loginInfo: true,
                loadingProfile: false,
            }));
            return undefined;
        }

        dispatch(setUser({
            accessToken: token,
            loginInfo: true,
            loadingProfile: true,
        }));

        axios.get(`${url}/passenger/v1/get-my-profile`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then((res) => {
                if (cancelled) return;

                const data = res?.data?.data || {};
                dispatch(setUser({
                    name: data.full_name || "",
                    idCode: data.national_code || "",
                    birthDate: data.birth_date || "",
                    gender: data.gender || "",
                    address: data.address || "",
                    status: data.status || "",
                    mobile: data.mobile || "",
                    accessToken: token,
                    loginInfo: true,
                    loadingProfile: false,
                }));
            })
            .catch((error) => {
                if (cancelled) return;

                const status = error?.response?.status;
                dispatch(setHandleError(error?.response?.data?.message || error.message));

                // Only destroy the saved token for a real auth failure.
                if (status === 401 || status === 403) {
                    localStorage.removeItem("accessToken");
                    dispatch(setUser({
                        accessToken: null,
                        loginInfo: true,
                        loadingProfile: false,
                    }));
                    return;
                }

                // Network/server failures must not log the user out.
                dispatch(setUser({
                    accessToken: token,
                    loginInfo: true,
                    loadingProfile: false,
                }));
            });

        return () => {
            cancelled = true;
        };
    }, [dispatch, token]);

    return null;
};

export default GetProfile;
